import { Action, configureStore } from '@reduxjs/toolkit';
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import { AppStore } from '../types';
import startupReducer, { startUp, startUpEffect } from './startupReducer';
import sysConfigReducer, { systemConfigEffect } from './sysConfigReducer';
import routeNavReducer, { routeNavEffect } from './routeNavReducer';
import goodsCatReducer, { goodsCatEffect } from './goodsCatReducer';
import userInfoReducer, { userInfoEffect } from './userInfoReducer';
import goodsListReducer, { goodsListEffect } from './goodsListReducer';
import goodsDetailReducer, { goodsDetailEffect } from './goodsDetailReducer';
import protocolReducer, { protocolEffect } from './protocolReducer';

// 所有的Effect放到这里
const effectData: { [x: string]: Function } = Object.assign(
  {},

  startUpEffect,
  systemConfigEffect,
  routeNavEffect,
  goodsCatEffect,
  userInfoEffect,
  goodsListEffect,
  goodsDetailEffect,
  protocolEffect,
  {}
);

// 数据中间件 这里综合了所有Effect 已配置到store里 所以store里不需要再动了
const dataMiddleWare = (storeApi: ToolkitStore) => (next: Function) => (action: Action) => {
  next(action);
  let fn = effectData[action.type];
  if (fn) {
    fn(storeApi, action);
  }
};

// 清除数据中间件 清除所有用户相关数据 用于注销
const logoutMiddleware: any = (storeApi: ToolkitStore) => (next: Function) => (action: Action) => {
  next(action);
  if (action.type === 'logout/logoutRequest') {
    for (let keys of Object.keys(effectData)) {
      if (keys.includes('/clear')) {
        effectData[keys](storeApi);
      }
    }
  }
};

// 打印中间件 输出store日志
const printMiddleware: any = (storeApi: ToolkitStore) => (next: Function) => (action: Action) => {
  console.log('ACTION_TYPE:', action.type, { action, store: storeApi.getState() });
  next(action);
};

const store: ToolkitStore<AppStore> = configureStore({
  reducer: {
    // 所有reducer放到这里
    startup: startupReducer,
    systemConfig: sysConfigReducer,
    routeNav: routeNavReducer,
    goodsCat: goodsCatReducer,
    user: userInfoReducer,
    goodsList: goodsListReducer,
    goodsDetail: goodsDetailReducer,
    protocol: protocolReducer,
  },
  middleware: [printMiddleware, dataMiddleWare, logoutMiddleware],
});

export default store;

store.dispatch(startUp('start'));
